/* eslint-disable no-loop-func */
import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import * as Constants from '../api/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function createRow(id, label, minusCommand, plusCommand) {
  return { id, label, minusCommand, plusCommand, state: '...', offset: '...' };
}

export default function HPDashboardThermistorsAnalog() {
  const state = useContext(MainContext).state;
  const deviceId = state.selectedDevice;

  const r3 = state.R3.split(',');
  const re = state.RE.split(',');

  const rows = [
    createRow(0, 'Water In Temp', 'HPWaterInc', 'HPWaterDec'),
    createRow(1, 'Water Out Temp', null, null),
    createRow(2, 'Ambient Temp', 'HPAmbientInc', 'HPAmbientDec'),
    createRow(3, 'Condenser Temp', 'HPCondensorInc', 'HPCondensorDec'),
    createRow(4, 'Comp Inlet Temp', 'HPCompInletInc', 'HPCompInletDec'),
    createRow(5, 'Comp Outlet Temp', 'HPCompOutletInc', 'HPCompOutletDec'),
    createRow(6, 'Heat Exch. Inlet Temp', 'HPHeatExcInletInc', 'HPHeatExcInletDec'),
    createRow(7, 'Heat Exch. Outlet Temp', 'HPHeatExcOutletInc', 'HPHeatExcOutletDec'),
    createRow(
      8,
      'Water Heat Exch. Outlet Temp',
      'HPWaterHeatExcOutletInc',
      'HPWaterHeatExcOutletDec'
    ),
    createRow(
      9,
      'Thermistor Spare Temp',
      'HPThermistorTempInc',
      'HPThermistorTempDec'
    ),
    createRow(
      10,
      'Mains Voltage',
      'HPMainsVoltageInt',
      'HPMainsVoltageDec'
    ),
  ];

  const fmtTemp10 = (val) =>
    val === undefined ? '...' : val === 0 ? '0°C' : (val / 10.0).toFixed(1) + '°C';

  const fmtVolt10 = (val) =>
    val === undefined ? '...' : val === 0 ? '0V' : (val / 10.0).toFixed(1) + 'V';

  if (re[1] === '1') {
    rows[0].state = fmtTemp10(re[13]);
    rows[1].state = fmtTemp10(re[14]);
    rows[2].state = re[10] ? `${re[10]}°C` : '...';
    rows[3].state = re[11] ? `${re[11]}°C` : '...';

    rows[0].offset = re[61] ?? '...';
    rows[1].offset = re[62] ?? '...';
    rows[2].offset = r3[23] ?? '...';
    rows[3].offset = r3[24] ?? '...';
    rows[4].offset = re[61] ?? '...';
    rows[5].offset = re[62] ?? '...';
    rows[6].offset = re[55] ?? '...';
    rows[7].offset = re[56] ?? '...';
    rows[8].offset = re[65] ?? '...';
    rows[9].offset = re[67] ?? '...';
    rows[10].offset = re[69] ?? '...';
  } else if (re[1] === '2') {
    rows[0].state = fmtTemp10(re[13]);
    rows[1].state = fmtTemp10(re[14]);
    rows[2].state = fmtTemp10(re[7]);
    rows[3].state = fmtTemp10(re[8]);
    rows[4].state = fmtTemp10(re[10]);
    rows[5].state = fmtTemp10(re[9]);
    rows[6].state = fmtTemp10(re[11]);
    rows[7].state = fmtTemp10(re[12]);
    rows[8].state = fmtTemp10(re[64]);
    rows[9].state = fmtTemp10(re[66]);
    rows[10].state = re[68] ? `${re[68]}V` : '...';

    rows[0].offset = re[61] ?? '...';
    rows[1].offset = re[62] ?? '...';
    rows[2].offset = re[59] ?? r3[23] ?? '...';
    rows[3].offset = re[60] ?? r3[24] ?? '...';
    rows[4].offset = re[61] ?? '...';
    rows[5].offset = re[62] ?? '...';
    rows[6].offset = re[55] ?? '...';
    rows[7].offset = re[56] ?? '...';
    rows[8].offset = re[65] ?? '...';
    rows[9].offset = re[67] ?? '...';
    rows[10].offset = re[69] === undefined ? '...' : (re[69] / 10.0).toFixed(1);
  }

  const sendCommand = (command, value) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        DeviceId: deviceId,
        Command: command,
        Value: value,
      }),
      credentials: 'include',
    };

    fetch(Constants.baseURL + Constants.apiSendCommand, requestOptions)
      .then((response) => {
        if (response.ok) {
          toast.success('Command sent successfully. Refreshing...', {
            position: 'top-right',
            autoClose: 10000,
          });

          setTimeout(() => state.refreshDeviceRF(deviceId), 6000);
          setTimeout(() => state.getUserDeviceRf(deviceId), 12000);
        } else {
          toast.error('Send failed. Please try again', {
            position: 'top-right',
            autoClose: 5000,
          });
        }
      })
      .catch((error) => console.log('request failed', error));
  };

  const handleAdjust = (cmd) => {
    if (!cmd) return;
    sendCommand(cmd, '');
  };

  return (
    <>
      <ToastContainer />

      <Typography
        component="h2"
        variant="h6"
        color="white"
        sx={{ fontWeight: 600, mb: 2 }}
      >
        Thermistors &amp; Analog
      </Typography>

      <Grid container spacing={2}>
        {rows.map((row) => (
          <Grid item xs={12} md={6} lg={4} key={row.id}>
            <Paper
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                display: 'flex',
                flexDirection: 'column',
                height: 150,
              }}
            >
              {/* Label */}
              <Typography
                variant="subtitle2"
                sx={{
                  color: 'rgba(255,255,255,0.9)',
                  fontWeight: 700,
                  fontSize: 14,
                }}
              >
                {row.label}
              </Typography>

              {/* Current value */}
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: 13,
                  color: 'text.disabled',
                }}
              >
                {row.state}
              </Typography>

              {/* Spacer to push controls to bottom */}
              <Box sx={{ flexGrow: 1 }} />

              {/* Controls row: buttons + offset pill */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mt: 1,
                  gap: 1.5,
                }}
              >
                {/* - / + buttons */}
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => handleAdjust(row.minusCommand)}
                    sx={{
                      minWidth: 36,
                      px: 1.2,
                      color: 'rgba(255,255,255,0.9)',
                      borderColor: 'rgba(255,255,255,0.4)',
                      '&:hover': {
                        borderColor: 'white',
                        bgcolor: 'rgba(255,255,255,0.08)',
                      },
                    }}
                  >
                    -
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => handleAdjust(row.plusCommand)}
                    sx={{
                      minWidth: 36,
                      px: 1.2,
                      color: 'rgba(255,255,255,0.9)',
                      borderColor: 'rgba(255,255,255,0.4)',
                      '&:hover': {
                        borderColor: 'white',
                        bgcolor: 'rgba(255,255,255,0.08)',
                      },
                    }}
                  >
                    +
                  </Button>
                </Box>

                {/* Offset pill */}
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: 13,
                    color: 'text.disabled',
                  }}
                >
                  Offset: {row.offset}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
